export default __webpack_public_path__ + "static/media/resume.e34b4dee.svg";